import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';

import {
  Overlay,
  OverlayRef
} from '@angular/cdk/overlay';

import {
  TemplatePortal
} from '@angular/cdk/portal';

import {
  ViewContainerRef
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-workflow-current-activity',
  standalone: false,
  templateUrl: './workflow-current-activity.component.html',
  styleUrl: './workflow-current-activity.component.scss'
})
export class WorkflowCurrentActivityComponent {

  @Input() row!: any;

  @Input() mode!: 'applicationNumber' | 'currentActivity';

  @Output() openActivity = new EventEmitter<{
    applicationId: string;
    activityDataId: string;
  }>();

  @Output() openSummary = new EventEmitter<{
    applicationId: string;
  }>();

  @Output() openApplication = new EventEmitter<string>();

  @ViewChild('activityDropdown')
  activityDropdown!: TemplateRef<any>;
private closeDropdownTimeout: any;
private static appViewOpening = false;

  private overlayRef?: OverlayRef;
  private static activeOverlayRef?: OverlayRef;
  private scrollHandler = (): void => {
  if (this.overlayRef) {
    this.closeOverlay();
  }
};
@HostListener('document:scroll', ['$event'])
onScroll(): void {
  if (this.overlayRef) {
    this.closeOverlay();
  }
}
  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef
  ) {
      document.addEventListener('scroll', this.scrollHandler, true);

  }
      @ViewChild('activityText')
    activityText!: ElementRef<HTMLElement>;
    showTooltip = false;

    updateOverflowTooltip(
      event: Event,
      tooltip: MatTooltip
    ): void {
      const host = event.currentTarget as HTMLElement;
      const text = this.activityNames;

      const shouldShow =
        !!text &&
        host.scrollWidth > host.clientWidth;

      tooltip.message = shouldShow ? text : '';
      tooltip.disabled = !shouldShow;

      if (shouldShow) {
        tooltip.show(0);
      }
    }

    hideOverflowTooltip(tooltip: MatTooltip): void {
      tooltip.hide(0);
    }

ngOnDestroy(): void {
  document.removeEventListener('scroll', this.scrollHandler, true);
  this.closeOverlay();
}

  get activity() {
    return Array.isArray(this.row?.currentActivityDetails)
      ? this.row.currentActivityDetails[0]
      : null;
  }

  get activities(): any[] {
    return Array.isArray(this.row?.currentActivityDetails)
      ? this.row.currentActivityDetails.filter(
          (activity: any) => activity?.activityName
        )
      : [];
  }

  get activityNames(): string {
    return this.activities
      .map((activity: any) => activity.activityName)
      .join(', ');
  }

  onApplicationClick(event: MouseEvent): void {
    event.stopPropagation();

    if (!this.row?.applicationId) {
      return;
    }

    if (
      this.row.applicantStatus === 'In Progress' ||
      this.row.applicantStatus === 'Incomplete' ||
      this.row.applicantStatus === 'Action Needed'
    ) {
      this.openApplication.emit(this.row.applicationId);
    } else {
      this.openSummary.emit({
        applicationId: this.row.applicationId
      });
    }
  }
  private closeOverlay(): void {
  if (this.overlayRef) {
    this.overlayRef.detach();
    this.overlayRef.dispose();

    if (
      WorkflowCurrentActivityComponent.activeOverlayRef ===
      this.overlayRef
    ) {
      WorkflowCurrentActivityComponent.activeOverlayRef = undefined;
    }

    this.overlayRef = undefined;
  }
}

selectedActivityDataId?: string;

onActivityClick(
  activity: any,
  event: MouseEvent
): void {
  event.stopPropagation();

  if (
    !this.row?.applicationId ||
    !activity?.activityDataId
  ) {
    return;
  }

  this.selectedActivityDataId = activity.activityDataId;

  // Close dropdown before navigation
  this.closeOverlay();

  this.openActivity.emit({
    applicationId: this.row.applicationId,
    activityDataId: activity.activityDataId
  });
}

static setAppViewOpening(value: boolean): void {
  WorkflowCurrentActivityComponent.appViewOpening = value;
}
openActivitiesDropdown(event: MouseEvent): void {
     event.stopPropagation();

  if (
    WorkflowCurrentActivityComponent.appViewOpening ||
    this.activities.length <= 1
  ) {
    return;
  }

  clearTimeout(this.closeDropdownTimeout);

  WorkflowCurrentActivityComponent.closeActiveDropdown();

  this.closeOverlay();


  const element = event.currentTarget as HTMLElement;

  const positionStrategy = this.overlay
    .position()
    .flexibleConnectedTo(element)
    .withPositions([
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top'
      },
      {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom'
      }
    ])
    .withFlexibleDimensions(false)
    .withPush(true);

  this.overlayRef = this.overlay.create({
    positionStrategy,
    scrollStrategy: this.overlay.scrollStrategies.noop(),
    hasBackdrop: false
  });

  // Store this as the globally active dropdown
  WorkflowCurrentActivityComponent.activeOverlayRef = this.overlayRef;

  this.overlayRef.attach(
    new TemplatePortal(
      this.activityDropdown,
      this.viewContainerRef
    )
  );
}

static closeActiveDropdown(): void {
  WorkflowCurrentActivityComponent.activeOverlayRef?.dispose();
  WorkflowCurrentActivityComponent.activeOverlayRef = undefined;
}
closeActivitiesDropdown(): void {
  clearTimeout(this.closeDropdownTimeout);

  this.closeDropdownTimeout = setTimeout(() => {
    this.closeOverlay();
  });
}

keepDropdownOpen(): void {
  clearTimeout(this.closeDropdownTimeout);
}
onDropdownClick(event: MouseEvent): void {
  event.stopPropagation();
}
}